var React = require('react');
var lodash = require('lodash').noConflict();

class StateDebugger extends React.Component {
    constructor(props) {
        super(props);

        this.wrapperStyle = {
            position: 'absolute',
            top: '200px',
            right: '-150px',
            width: '600px',
            backgroundColor: '#F8DF8D',
            color: 'black',
            zIndex: 999,
            border: '3px solid black',
            borderRadius: '5px',
            margin: '10px',
            padding: '10px'
        }

        this.getStepDataMarkup = this.getStepDataMarkup.bind(this);
    }

    getStepDataMarkup() {
        var stepData = this.props.appState.stepState[this.props.appState.currentStep];
        var markup = [];
        for (var prop in stepData) {
            if (typeof stepData[prop] != 'undefined') {
                markup.push(<div key={prop}><span style={{ fontWeight: 'bold' }}>{prop}: </span><span style={{ color: 'blue', fontWeight: 'bold' }}>{stepData[prop].toString()}</span></div>);
            }
        }

        return <div style={{border: '2px solid black', padding: '10px', borderRadius: '5px'}}><span>Step State:</span>{markup}</div>;
    }

    render() {
        if (!this.props.appState.debugMode) {
            return null;
        }

        const stepMarkup = this.getStepDataMarkup();
        return <div className={"state-debugger-container"} style={this.wrapperStyle}>
            <div>
                <span>
                    User Logged In: {this.props.appState.userLoggedIn ? "True" : "False"}
                </span>
            </div>
            <div>
                <span>
                    AppType: {this.props.appState.appType ? this.props.appState.appType : "Not Set"}
                </span>
            </div>
            <div>
                <span>
                    productType: {this.props.appState.productType ? this.props.appState.productType : "Not Set"}
                </span>
            </div>
            <div>
                <span>
                    rateType: {this.props.appState.rateType ? this.props.appState.rateType : "Not Set"}
                </span>
            </div>
            <div>
                <span>
                    primaryPracticeLocation: {this.props.appState.primaryPracticeLocation ? this.props.appState.primaryPracticeLocation : "Not Set"}
                </span>
            </div>
            <div>
                <span>
                    Current Step: {this.props.appState.currentStep}
                </span>
            </div>
            <div>
                <span>
                    isMilitary: {this.props.appState.isMilitary ? "True" : "False"}
                </span>
            </div>
                <div>
                    <span>
                        isInternational: {this.props.appState.isInternational ? "True" : "False"}
                    </span>
            </div>
            <div>
                <span>
                    isGovernmentEmployee: {this.props.appState.isGovernmentEmployee ? "True" : "False"}
                </span>
            </div>
            <div>
                <span>
                    {stepMarkup}
                </span>
            </div>
        </div>;
    }
}

module.exports = StateDebugger;